import React, { useState } from "react";
import { api } from "@/lib/api";
import { fileUrl } from "@/lib/api";
import { UploadSimple, X } from "@phosphor-icons/react";

export default function ImageUploader({ value, onChange, label = "Cover image", testId = "image-uploader" }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const handleFile = async (file) => {
    if (!file) return;
    setErr("");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
    } catch (e) {
      setErr("Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid={testId}>
      <div className="eyebrow text-muted-foreground mb-2">{label}</div>
      {value ? (
        <div className="relative border border-border">
          <img src={fileUrl(value)} alt="" className="w-full h-56 object-cover" />
          <button
            type="button"
            onClick={() => onChange(null)}
            className="absolute top-2 right-2 h-8 w-8 grid place-items-center bg-background border border-border hover:bg-destructive hover:text-destructive-foreground"
            aria-label="Remove"
            data-testid={`${testId}-remove`}
          >
            <X size={14} />
          </button>
        </div>
      ) : (
        <label className="flex flex-col items-center justify-center h-40 border border-dashed border-border bg-card hover:bg-secondary/50 cursor-pointer transition-colors">
          <UploadSimple size={20} weight="duotone" />
          <span className="mt-2 text-sm text-muted-foreground">{busy ? "Uploading..." : "Click to upload (JPG, PNG, WebP, max 8MB)"}</span>
          <input
            type="file"
            accept="image/*"
            className="hidden"
            onChange={(e) => handleFile(e.target.files?.[0])}
            data-testid={`${testId}-input`}
          />
        </label>
      )}
      {err ? <div className="text-sm text-destructive mt-2">{err}</div> : null}
    </div>
  );
}
